<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }

</script>

<style>
  @import 'element-ui/lib/theme-chalk/index.css';
  @import './styles/index.scss';
  * {
    margin: 0;
    padding: 0;
  }

  html, body {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  #app {
    font-family: "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100%;
  }
  .el-button--min {
    padding: 5px 8px!important;
  }
  .check_select{
    width: 96px;
    margin-left: 8px;
  }
  .right .el-select {
    margin-right: 20px;
  }
  .right .search .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .right .search .el-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100%;
  }

  .el-cascader {
    width: 100%;
  }

    /* 修改单选框按钮组样式 */
  .el-radio-button:first-child .el-radio-button__inner {
    border-radius: 0;
  }

  .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0;
  }

  .el-radio-button__inner {
    margin: 0 2px;
    border-left: 1px solid #DCDFE6;
  }

  .el-radio-group .el-radio-button,
  .el-checkbox-group .el-checkbox-button {
    margin-bottom: 5px;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-range-editor {
    width: 100%;
  }

  .el-date-editor .el-range-separator {
    width: auto;
  }

  .input-with-button .el-input-group__append {
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
  }

    /* 取消表单最后一行的间距 */
  .el-form-item:last-child {
    margin-bottom: 0;
  }

  .row {
    display: flex;
    flex-direction: row;
  }

  .column {
    display: flex;
    flex-direction: column;
  }

  .row-center {
    justify-content: center;
  }

  .column-center {
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue